import {
    fetchAddressesListFromApiPP, fetchDistricts,
    resetSelectElement, getLanguageFromUrl,
    calculateZoomLevel, showMapError,
    hideMapError, validateAddressInput, populateFormData,
    showPointTooltip, setupAutocompleteRenderer,
    destroyAutocomplete, mapZoomToDistance,
    sortPointsByDistance, drawDistanceCircle,
    addPopupForSelectedPoint, ppmapDistrictSelectReset,
    fetchNearestPointsHtml, initAutocomplete,
    attachPointsListEvents
} from './pp-maps-helper';
class MapCurrencyExchange {
    constructor(){
        this.mapa = {};
        this.defaultMapPoint = {lat:52.067519, lng:19.4770837, val:'Piątek Łódzkie Polska'};
        this.selectedPoint = {};
        this.urlPage = new URL (document.URL);
        this.urlParams =  new URLSearchParams(this.urlPage.search);
        this.mapPOILoaderResultTable = document.querySelector('#map-point-table');

        this.ppmapSearchAdress = document.querySelector('#ppmapSearchAdress');
        this.ppmapSearchAdressButton = document.querySelector('#ppmapSearchAdressButton');
        this.ppMapLocationButton = document.querySelector('#ppMapLocationButton');

        this.formSearchPoi = document.querySelector('#searchPoiItem');
        this.ppmapDistrictPreloader = document.querySelector('#ppmapDistrictPreloader');
        this.ppmapDistance = document.querySelector('#ppmapDistance');
        this.ppmapProvince = document.querySelector('#ppmapProvince');
        this.ppmapDistrict = document.querySelector('#ppmapDistrict');
        this.ppmapError = document.querySelector('#ppmapError');


        this.distanceCircleOnMap = null;
        this.distanceCircleTimeout = null;

        this.markerPopupSelectedPoint = {};

        this.setSubmit();
        this.makeInteractiveZoom();
        this.makeInteractiveProvince();
        this.makeInteractiveDistrict();
        this.autocompleteInput();
    }

    setSubmit() {

        this.ppmapSearchAdressButton.addEventListener('click', ()=>{
            submitForm();
        });

        this.ppmapSearchAdress.addEventListener('keydown', (e) => {
            if (e.key === "Enter") {
                e.preventDefault(); // Prevent the default form submission
                submitForm();
            }
        });

        const submitForm = () => {
            this.prepareData();

            if(this.formValidate()) {

                this.fetchAddressesListFromApiPP()
                    .then(data => {
                        if(data.length>0){
                            let e = { 'selected': {
                                    'lat': data[0].latitude,
                                    'lng': data[0].longitude,
                                    'val': data[0].label
                                }
                            }

                            this.ppmapSearchAdress.value = data[0].value;
                            this.ppwidgetOnSubmit(e);
                        } else {
                            this.showMapError();
                        }
                    });

            } else {
                console.log('Niepoprawnie wypełniony formularz!');
            }
        }
    }

    fetchAddressesListFromApiPP() {
        const apiKey = (typeof ppSettings !== 'undefined') ? ppSettings.ppkey : '';
        return fetchAddressesListFromApiPP(this.ppmapSearchAdress.value, apiKey);
    }

    autocompleteInput() {

        this.prepareData();

        initAutocomplete({
            input: this.ppmapSearchAdress,
            baseUrl: this.urlPage.origin,
            currentTab: 'tabAll',
            extraParams: { 'ppmapBox_CurrencyExchange': 1 },
            fetchAddressesFn: () => this.fetchAddressesListFromApiPP(),
            onSelect: (e, isAddress) => {
                this.ppmapProvince.value = 0;
                this.ppmapDistrictSelectReset('powiat');

                if (!isAddress) {
                    this.addPopupForSelectedPoint([e.selected.lat, e.selected.lng]);
                } else {
                    this.removePopupForPrevSelectedPoint();
                }
                this.ppwidgetOnSubmit(e, isAddress);
            }
        });

    }

    removePopupForPrevSelectedPoint() {
        const currentMap = PPWidgetApp.getMap();
        this.markerPopupSelectedPoint ? currentMap.removeLayer(this.markerPopupSelectedPoint) : '';
    }
    autocompleteInputDestroy() {
        destroyAutocomplete(this.ppmapSearchAdress);
    }

    showMapError(message) {
        showMapError(this.ppmapError, message);
    }

    hideMapError() {
        hideMapError(this.ppmapError);
    }

    formValidate() {
        this.hideMapError();
        if (!validateAddressInput(this.ppmapSearchAdress.value)) {
            this.showMapError('Wybierz adres z listy lub adres jest zbyt krótki min. 3 znaki');
            return false;
        }
        return true;
    }

    openTooltip(id) {
        showPointTooltip(id, this.getLanguage(), this.urlPage.origin, true);
    }


    markElementOnList(latitude, longitude) {
        console.log('...jestem tutaj markElementOnList...');
        console.log('...lista z boku...');
    }

    makeInteractiveZoom() {
        this.ppmapDistance.addEventListener('change', (e) => {
            this.ppmapZoom = this.calculateMapZoom();
            const map = PPWidgetApp.getMap();

            if(this.ppmapSearchAdress.value) {
                map.setView(this.selectedPoint, this.ppmapZoom);
                this.drawDistanceCircle();
                this.getFilteredMarkers();
            }
        });
    }

    makeInteractiveProvince() {
        this.ppmapProvince.addEventListener('change',(e)=>{

            this.ppmapDistance.value = 0;
            this.ppmapDistrictSelectReset('powiat');

            if('0'!==e.target.value) {
                if(!this.selectedPoint?.val.toLowerCase().includes(e.target.value)) {
                    this.selectedPoint = this.defaultMapPoint;
                    this.ppmapSearchAdress.value = null;
                }

                this.prepareData();
                this.getFilteredMarkers(true);

                let xhr = new XMLHttpRequest();
                let url = this.urlPage.origin + "/wp-content/plugins/pp-poiloader/province.php";

                let data = new FormData();
                data.append('province',e.target.value);
                data.append('lang',this.getLanguage());
                xhr.open("POST", url, true);
                xhr.send(data);

                let provinceLabel = 'powiat';
                provinceLabel = ('en'==this.getLanguage()) ? 'province' : 'powiat';

                this.ppmapDistrictPreloader.style.display = 'flex';

                fetchDistricts(e.target.value, this.getLanguage(), this.urlPage.origin)
                    .then(data => {
                        const provinceLabel = (this.getLanguage() === 'en') ? 'province' : 'powiat';
                        resetSelectElement(this.ppmapDistrict, provinceLabel);

                        data.district.forEach((item) => {
                            const myOption = document.createElement("option");
                            myOption.text = item;
                            myOption.value = item;
                            this.ppmapDistrict.appendChild(myOption);
                        });
                    })
                    .catch(error => console.error('Error fetching districts:', error))
                    .finally(() => {
                        this.ppmapDistrictPreloader.style.display = 'none';
                    });

                xhr.onreadystatechange = () => {
                    if (xhr.readyState === 4) {
                        //console.log(xhr.responseText);
                    }
                };

                xhr.onerror = () => console.log("Request failed");

            } else {
                let pointDetails = this.ppmapSearchAdress.value ? this.selectedPoint : this.defaultMapPoint;
                let showMarker = !!this.ppmapSearchAdress.value;
                this.ppwidgetOnSubmit({selected: pointDetails}, showMarker);
                // this.ppmapDistrictSelectReset('powiat');
            }
        })
    }

    makeInteractiveDistrict() {
        this.ppmapDistrict.addEventListener('change',(e)=>{
            this.ppmapDistance.value = 0;
            // this.prepareData();
            this.getFilteredMarkers(true);
        });
    }

    ppmapDistrictSelectReset(item) {
        ppmapDistrictSelectReset( this.ppmapDistrict, this.getLanguage(), item );
    }

    prepareData() {
        this.formSearchPoiData = new FormData(this.formSearchPoi);
        populateFormData(this.formSearchPoi, this.formSearchPoiData);
    }


    onCurrencyLoad(xhr){
        const currentMap = PPWidgetApp.getMap();
        let markers = [];
        let res;
        const clearOldMarkers = true;

        if (xhr.status == 200){

            if(clearOldMarkers) PPWidgetApp.clearMarkers();

            res = JSON.parse(xhr.response);

            // if (!res || res.length === 0) {
            //     alert("Nie znaleziono żadnych punktów spełniających wybrane kryteria.");
            //     this.mapPOILoaderResultTable.classList.add('d-none');
            //     return;
            // }


            this.nearestPoints(res);
            res.forEach((item,index) =>{

                let markerDetails = {
                    latitude: item.latitude,
                    longitude: item.longitude,
                    type: item.typ,
                    pni: item.pni
                };

                markers[index] = PPWidgetApp.generateMarker(markerDetails).on('click', ()=>{
                    this.openTooltip(item.pni);
                    currentMap.setView([item.latitude, item.longitude], currentMap._zoom);
                    this.markElementOnList(item.latitude, item.longitude);
                });

                if(clearOldMarkers) PPWidgetApp.addMarkers(markers);

                if(!markers.length) {
                    currentMap.setView(this.defaultMapPoint, 5.5);
                    return;
                }

                if(this.ppmapZoom === 0) {
                    let bounds = PPWidgetApp.getBounds(markers);
                    PPWidgetApp.fitBounds(bounds);
                    if (currentMap) {
                        setTimeout(() => {
                            let currentZoom = currentMap.getZoom();
                            currentMap.setZoom(currentZoom - 0.5);
                        }, 400);
                    }


                } else {
                    currentMap.setView(this.selectedPoint, currentMap._zoom);
                }
            });
        } else {
            console.log(`Error ${xhr.status}: ${xhr.statusText}`);
        }
    }
    onCurrencyReadyStateChange(xhr){
        // console.log(xhr);
        // console.log(xhr.readyState);
    }
    onCurrencyError(xhr){
        console.log('CurrencyError');
        console.log(xhr);
    }

    onlyCurrencyExchange(data) {
        data.append('ppmapBox_Filters', 'tabAll');
        data.append('ppmapBox_CurrencyExchange', 1);
        data.append('ppmapBox_Days', 'dni robocze');
        data.append('ppmapBox_PickupAtPocztexPoint', 0);
        data.append('ppmapBox_pocztexBroadcasting', 0);
        data.append('ppmapBox_flixBus', 0);
        data.append('ppmapBox_PostOfficeBoxes', 0);
        data.append('ppmapBox_Weight20Plus', 0);
        data.append('ppmapBox_Weight30To50', 0);
        data.append('ppmapBox_MoneyExpress', 0);
        data.append('ppmapBox_ECommerce', 0);
        data.append('ppmapBox_KEP', 0);
        data.append('ppmapBox_COD', 0);
        data.append('ppmapBox_card', 0);
        data.append('ppmapBox_HoursOfEmptying', 0);
        data.append('ppmapBox_SpecialNeeds', 0);
        data.append('ppmapBox_blik', 0);
    }

    setFilter(data) {
        data.append('tab', 'tabAll');
        data.append('lng', this.selectedPoint.lng);
        data.append('lat', this.selectedPoint.lat);
        data.append('val', this.selectedPoint.val);
        data.append('distance', this.ppmapDistance.value);
        data.append('province', this.ppmapProvince.value);
        data.append('district', this.ppmapDistrict.value);

        data.append('ppmapSearchAdress', null);
        data.append('ppmapDistance', this.ppmapDistance.value);
        data.append('ppmapProvince', this.ppmapProvince.value);
        data.append('ppmapDistrict', this.ppmapDistrict.value);
    }

    getLanguage() {
        return getLanguageFromUrl(this.urlPage.pathname);
    }

    calculateMapZoom() {
        const manualZoom = Number(this.urlParams.get('zoom')) || 0;
        this.ppmapZoom = calculateZoomLevel(
            this.ppmapDistance.value,
            this.ppmapSearchAdress.value,
            this.ppmapProvince.value,
            manualZoom
        );
        return this.ppmapZoom;
    }

    getFilteredMarkers(clearOldMarkers = false){

        let xhr = new XMLHttpRequest();
        let url = this.urlPage.origin + "/wp-content/plugins/pp-poiloader/find-markers.php";
        let data = new FormData();

        // this.selectedPoint = this.defaultMapPoint;

        this.calculateMapZoom();
        this.setFilter(data);
        this.onlyCurrencyExchange(data)

        xhr.open("POST", url, true);
        xhr.send(data);
        xhr.onload = () => this.onCurrencyLoad(xhr);
        xhr.onreadystatechange = () => this.onCurrencyReadyStateChange(xhr);
        xhr.onerror = () => this.onCurrencyError(xhr);

    }

    nearestPoints(points){

        if(!points.length || (!this.ppmapSearchAdress.value && this.selectedPoint === this.defaultMapPoint && this.ppmapProvince.value === '0')) {
            this.mapPOILoaderResultTable.classList.add('d-none');
            return;
        }

        const currentMap = PPWidgetApp.getMap();
        let distanceSelect = Number(this.ppmapDistance.value);

        distanceSelect = distanceSelect ? this.ppmapDistance.value * 1000 : !this.ppmapSearchAdress.value && this.ppmapProvince.value !== '0' ? 1_000_000 : this.mapZoomToDistance(currentMap._zoom);
        distanceSelect = (distanceSelect == 2000) ? 5000 : distanceSelect;

        points = this.sortPointsFromTheCloses(points);
        let pointsLimit = 300;
        pointsLimit = (points.length < pointsLimit) ? points.length : pointsLimit;

        const tab = points.filter((point, idx) => point.distance <= distanceSelect && idx <= pointsLimit).map(point => point.pni);

        fetchNearestPointsHtml(
            tab,
            this.selectedPoint,
            this.getLanguage(),
            this.urlPage.origin,
            true // true dla pp-currency.js, false dla template-ppmap.js
        )
            .then(html => {
                this.mapPOILoaderResultTable.innerHTML = html;
                this.mapPOILoaderResultTable.classList.remove('d-none');
                attachPointsListEvents(this.mapPOILoaderResultTable, PPWidgetApp.getMap(), this, true);
                if (currentMap) {
                    currentMap.invalidateSize();
                    // if (this.selectedPoint && this.selectedPoint.lat) {
                    //     currentMap.setView(this.selectedPoint, currentMap.getZoom());
                    // }
                }
            })
            .catch(error => {
                this.mapPOILoaderResultTable.classList.add('d-none');
                console.error(error);
            });

    }

    sortPointsFromTheCloses(points) {
        return sortPointsByDistance(points, this.selectedPoint);
    }

    mapZoomToDistance(zoom) {
        return mapZoomToDistance(zoom);
    }

    addPopupForSelectedPoint(coordinates) {
        this.markerPopupSelectedPoint = addPopupForSelectedPoint(
            PPWidgetApp.getMap(),
            coordinates,
            this.markerPopupSelectedPoint,
            'Wybrany punkt' // Możesz tu wpisać dowolny tekst
        );
    }

    //==================================================
    ppwidgetOnSubmit(selectedPoint,showMarker = true){

        selectedPoint = selectedPoint ?? { selected: this.defaultMapPoint };
        this.selectedPoint = selectedPoint.selected; // Przypisanie wybranego punktu

        let mapa = PPWidgetApp.getMap();

        this.getFilteredMarkers(true);
        this.calculateMapZoom();

        if (this.ppmapSearchAdress.value) {
            mapa.setView(this.selectedPoint, this.ppmapZoom);
            this.drawDistanceCircle();
        } else {
            mapa.setView([this.defaultMapPoint.lat, this.defaultMapPoint.lng], 5.5);
        }

        if (showMarker) {
            if (this.selectedPointMarker) mapa.removeLayer(this.selectedPointMarker);
            this.selectedPointMarker = L.marker(this.selectedPoint).addTo(mapa);
            this.selectedPointMarker.bindPopup(`<b>${this.selectedPoint.val}</b><br>wybrana lokalizacja.`).openPopup();
        }

    }

    drawDistanceCircle() {
        const result = drawDistanceCircle(
            PPWidgetApp.getMap(),
            this.selectedPoint,
            this.ppmapDistance.value,
            this.distanceCircleOnMap,
            this.distanceCircleTimeout
        );
        this.distanceCircleOnMap = result.circle;
        this.distanceCircleTimeout = result.timeout;
    }

    //==================================================
    start(){
        PPWidgetApp.embedMap('map',{ options: { basemapProvider: "AzureMaps", geocoderProvider: "Nominatim"} })
            .then(()=>{
                this.ppwidgetOnSubmit({selected: this.defaultMapPoint},false);

                const mapa = PPWidgetApp.getMap();

                if (this.ppMapLocationButton && mapa) {
                    mapa.on('locationfound', (e) => {
                        const userLocation = {
                            selected: {
                                lat: e.latlng.lat,
                                lng: e.latlng.lng,
                            }
                        };

                        this.ppwidgetOnSubmit(userLocation, false);
                        mapa.setView(e.latlng, 16);
                    });

                    mapa.on('locationerror', (e) => {
                        console.error('BŁĄD LOKALIZACJI: ', e.message);
                        alert('Błąd lokalizacji: ' + e.message);
                    });

                    this.ppMapLocationButton.addEventListener('click', (e) => {
                        e.preventDefault();

                        const mapElement = document.getElementById('map');
                        if (mapElement) {
                            mapElement.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center'
                            });
                        }

                        mapa.locate({
                            setView: true,
                            maxZoom: 16,
                            enableHighAccuracy: false,
                            timeout: 10000
                        });
                    });
                }
            });
    }

    //==================================================
}

document.addEventListener('DOMContentLoaded', (e)=>{
    let mapCurrencyExchange = new MapCurrencyExchange();
    mapCurrencyExchange.start();
});